export enum ReportedFeedbackUrgency {
  low = "low",
  high = "high",
}

export const ReportedFeedbackUrgencies = [
  {
    type: ReportedFeedbackUrgency.low,
    label: "Low: I can still grade.",
  },

  {
    type: ReportedFeedbackUrgency.high,
    label: "High: I cannot grade!",
  },
];
